import { $qs, $qsa } from '../../../src/js/utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);


function horizontalLinkScroller() {
    const container = $qs('[data-target="scroll-container"]');
    const sectionIntro = $qs('[data-target="scroll-section"]');
    const sections = $qsa('[data-target="scroll-section"] > div');
    
    if(window.innerWidth < 768) {
        var offset = 0;
    } else if(window.innerWidth < 1450) {
        var offset = 300;
    } else {
        var offset = 500;
    }
    const getMaxWidth = () => [...sections].reduce((val, section) => val + section.offsetWidth, offset);
    let maxWidth = getMaxWidth();
	maxWidth += sectionIntro.offsetWidth + window.innerWidth / 3

    //console.log(maxWidth);
    const timeline = gsap.timeline();

    timeline
    .to(sections, {
        x: () => window.innerWidth - maxWidth,
        ease: 'none',
    });

    // if($qs('.block--info-scroller')) {            
    //     var startPoint = `${$qs('.block--info-scroller').innerHeight}px top`
    //     // var startPoint = `2070px top`
    // } else {
    //     startPoint = '';
    // }

    ScrollTrigger.create({
        animation: timeline,
        trigger: container,
        pin: true,
        //pinSpacing: true,
        scrub: 0.8,
        // start: 'top top',
        //   snap: {snapTo: directionalSnap(timeline), duration: 0.5},
        invalidateOnRefresh: true,
        end: () => `+=${maxWidth}`,
        // markers: true
    });

    ScrollTrigger.sort();
}

function linkScroller() {
    // if (!$qs('.page-template-home')) return;
    if (!$qs('.block--link-scroller')) return;
    
    window.addEventListener('load', () => {
        horizontalLinkScroller();
    });

	const buttonScroll = document.querySelector('.scroll-button')

	buttonScroll.addEventListener('click', () => {
		window.scrollBy({
			top: window.innerWidth/3,
			behavior: 'smooth'
		});
	})
}

export default linkScroller;